module.exports = __webpack_public_path__ + "static/media/cases_anuncios_01a.0b6c5ef4.jpg";